export const abortControllerManager = {
  controllers: [],

  register(controller) {
    this.controllers.push(controller);
  },

  unregister(controller) {
    this.controllers = this.controllers.filter(registeredController => registeredController !== controller);
  },

  abort() {
    this.controllers.forEach(controller => controller.abort());
  },

  reset() {
    this.controllers = [];
  },
};
